<template>
    <div class="start-game-sec-comp" :style="{ 'background-image': 'url(static/img/start.gif)' }">
        <div class="lf-sec">
            <div class="progress" v-if="100 - progress || type == 2" :style="{ width: type == 1 || type == 3 ? `${100 - progress}%` : '100%', transition: progress > 0 ? '0.3s' : '' }">
                <div class="shadow" v-if="progress > 1 && (type == 1 || type == 3)"></div>
            </div>
            <div class="lf-inner">
                <!-- <span class="icon"></span> -->
                <div class="txt">
                    <span v-if="currentStatus == 0">开始游戏前请选择合适的账号类型</span>
                    <span v-else-if="currentStatus == 1">
                        <span>{{ startGameTxt[currentTxtIndex].text }}</span>
                    </span>
                    <span v-else-if="currentStatus == 2">
                        <template v-if="isAlike">
                            {{ `${gameInfo.title}（请勿在游戏内充值）` }}
                        </template>
                        <template v-else>
                            开始游戏前请选择合适的账号类型
                        </template>
                    </span>
                </div>
            </div>
        </div>
        <div class="rg-sec">
            <div @click.stop="handlerClick" class="inner" :class="{ 'no-show': !show }" v-if="false">
                <div class="play-txt">
                    <span class="sp1"> {{ realRightBtnTxt }} </span>
                    <span class="sp2" v-if="showChooseArr"><i></i></span>
                    <!-- 切换账号 -->
                    <span class="sp2 change-arr" v-if="showChangeArr" @click.stop="changeGameAccount"><i></i></span>
                </div>
                <div class="play-time" v-if="showPlayTime">已游玩：{{ useTime }}</div>
                <transition name="slide-up">
                    <div class="choose-wrap" :class="{ 'has-two-btn': showVipBtn }" v-show="show" @click="$event.stopPropagation()">
                        <div class="dv1 btn" @click="handlerClickStartGame(1)" v-if="showVipBtn">VIP账号</div>
                        <div class="dv2 btn" @click="handlerClickStartGame(2)">个人账号</div>
                    </div>
                </transition>
            </div>
            <div @click="handlerFree" class="inner" v-else>
                <div class="play-txt">
                    <!-- <span class="sp1" v-if="$store.state.limitFreeTime">{{ realRightBtnTxt }}</span>
                    <span class="sp1" v-else>领取免费时长</span>
                    <span class="sp2 change-arr" v-if="showChangeArr" @click.stop="changeGameAccount"><i></i></span> -->
                    <span class="sp1" data-agl-cvt="6">开始游戏</span>
                </div>
                <div class="play-time" v-if="showPlayTime">已游玩：{{ useTime }}</div>
            </div>
            <!-- 启动中的按钮遮罩 -->
            <div class="starting-cover" v-if="currentStatus == 1"></div>
        </div>
    </div>
</template>
<script>
import { getCookieToken, canPlayGame } from '@/utils/auth'
import { getLimitFree } from '@/http/api/user'
import { getAccountInfo, switchAccountInfo } from '@/http/api/order'
import { getEmailCode } from '@/http/api/common'
import { boxUserGameCreate } from '@/http/api/game'
import config from '@/http/config'

// 启动游戏过程中错误提示信息
const errorTxt = {
    1: 'steam启动进程已被关闭',
    2: '无法找到游戏客户端，请您请点击客户端右上角常见问题，查看指引操作流程，即可畅玩。',
    3: '无法找到游戏客户端，请您请点击客户端右上角常见问题，查看指引操作流程，即可畅玩。',
    4: '请联系客服，获取邮箱验证码',
    5: 'steam.exe启动了，但没有发现登录窗口',
    6: '您的steam登录已超时，账号已被释放，请检查本地网络状态或手动打开steam登录页面，再点击开始按钮重试',
    7: 'OCR识别库加载失败',
    8: '密码错误',
    9: '验证码错误'
}

// 启动游戏底部文字提示
const startGameTxt = {
    0: {
        text: '正在启动游戏平台，预计时长3分钟，请稍等'
    },
    1: {
        text: '建议打开游戏加速器，可更快进入游戏界面'
    },
    2: {
        text: '若启动过程中出现问题，请及时联系客服'
    },
    3: {
        text: '当前网络不佳，请检查网络状况或打开游戏加速器'
    }
}

export default {
    name: 'StartGameSec',
    props: {
        gameInfo: {
            type: Object,
            default: () => ({})
        },
        goods: {
            type: Object,
            default: () => ({})
        },
        userGameInfo: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            show: false,
            showChange: false,
            type: -1, // 1--个人账号 2-->vip账号 3-->点击领取免费时长
            firstShareSp: {},
            errorTxt,
            startGameTxt,
            currentTxtIndex: 0,
            progress: 0,
            pingValue: 0,
            changeAccountPayload: {}, // 密码错误切换账号is_e:99，游戏过程中切换账号is_e:0
            useTime: '0分钟'
        }
    },
    computed: {
        userId() {
            return this.$store.state.userInfo.id
        },
        is_vip: function() {
            return this.$store.state.vipInfo.is_vip
        },
        isStillFree() {
            let { limitFreeTime, serverTime } = this.$store.state
            let leftFreeTime = +new Date(limitFreeTime) / 1000 - serverTime
            if (this.gameInfo.is_family_free == 1) {
                return !limitFreeTime || leftFreeTime > 0 ? true : false
            } else {
                return false
            }
        },
        serverTime() {
            return this.$store.state.serverTime
        },
        currentStatus() {
            // 0--》没有启动 1--启动中 2--》启动成功
            return this.$store.state.currentStatus
        },
        currentGameId() {
            return this.$store.state.accountInfo.game_id
        },
        currentGoodsId() {
            return this.$store.state.accountInfo.goods_id
        },
        realRightBtnTxt() {
            if (this.currentStatus == 2) {
                if (this.gameInfo.game_id == this.currentGameId && this.currentGoodsId == (this.goods.goodsInfo && this.goods.goodsInfo.id)) {
                    return '退出游戏'
                } else {
                    return '开始游戏'
                }
            } else if (this.currentStatus == 1) {
                return '启动中'
            } else {
                return '开始游戏'
            }
        },
        showPlayTime() {
            const { game_id, goods_id } = this.$store.state.accountInfo
            return this.currentStatus == 2 && goods_id == this.firstShareSp.g_id && game_id == this.gameInfo.game_id
        },
        // 展示VIP账号按钮
        showVipBtn() {
            return this.goods.goodsInfo && this.goods.goodsInfo.id && JSON.stringify(this.firstShareSp) != '{}'
        },
        // 当前详情页的游戏信息和商品信息是否accountInfo里面的信息一致
        isAlike() {
            return this.gameInfo.game_id == this.currentGameId && this.currentGoodsId == (this.goods.goodsInfo && this.goods.goodsInfo.id)
        },
        // 选择账号箭头
        showChooseArr() {
            return !this.currentStatus || (this.currentStatus == 2 && (this.gameInfo.game_id != this.currentGameId || this.currentGoodsId != (this.goods.goodsInfo && this.goods.goodsInfo.id)))
        },
        // 切换账号箭头
        showChangeArr() {
            return this.currentStatus == 2 && this.isAlike && this.goods.goodsInfo && this.goods.goodsInfo.is_allow_change == 1 && this.firstShareSp.allocRule === 0
        }
    },
    watch: {
        isStillFree: {
            immediate: true,
            handler(cur) {
                console.log('isStillFree=======>', cur)
            }
        },
        goods: {
            deep: true,
            immediate: true,
            handler(cur) {
                if (cur && Array.isArray(cur.spList)) {
                    let item = this.goods.spList.find(v => v.mode == 1 && v.is_enable == 1)
                    if (item) {
                        this.firstShareSp = item
                    }
                }
            }
        },
        serverTime: {
            immediate: true,
            handler(cur) {
                if (cur) {
                    const { startTime } = this.$store.state.accountInfo
                    let txt = ''
                    if (startTime && cur) {
                        let time = parseInt(cur - startTime)
                        if (isNaN(time)) {
                            txt = '0分钟'
                        } else if (time >= 60 * 60) {
                            // 大于1小时或者等于1小时
                            txt = (time / 3600).toFixed(1) + '小时'
                        } else if (time < 60 * 60 && time >= 0) {
                            // 小于1小时按照分钟显示
                            txt = Math.floor(time / 60) + '分钟'
                        }
                    } else {
                        txt = '0分钟'
                    }
                    this.useTime = txt
                }
            }
        }
    },
    mounted() {
        window.addEventListener('click', this.handlerClickChooseOutside)
        this.$EventBus.$on('start-game', () => {
            this.startGame()
        })
    },
    beforeDestroy() {
        clearTimeout(this.getEmailCodeTimeId)
        clearTimeout(this.messageInterval)
        window.removeEventListener('click', this.handlerClickChooseOutside)
        this.$EventBus.$off('start-game')
    },
    methods: {
        handlerClickChooseOutside() {
            if (this.show) {
                this.show = false
            }
        },
        handlerClick() {
            if (this.currentStatus === 2) {
                if (this.isAlike) {
                    this.$NormalDialog.show({
                        msg: '您是否确定退出当前的游戏',
                        showConfirm: true,
                        confirmTxt: '确定',
                        confirmFn: () => {
                            this.userStopSteam()
                        }
                    })
                } else {
                    this.show = !this.show
                }
            } else if (this.currentStatus === 0) {
                this.show = !this.show
            }
        },
        handlerClickStartGame(type) {
            if (this.isClickBtn) return false
            this.isClickBtn = true
            this.tempClickTimeId = setTimeout(() => {
                clearTimeout(this.tempClickTimeId)
                this.isClickBtn = false
            }, 1500)

            if (!getCookieToken()) {
                return this.$Login.show({
                    scene: 'cb',
                    callback: () => {
                        this.$store.dispatch('getLimitFreeTime')
                    }
                })
            }
            this.type = type
            this.$Client.isSteamInstall()
        },
        handlerFree() {
            this.$EventBus.$emit('dl-client', 'start-btn')
            return false
            if (this.isClickBtn) return false
            this.isClickBtn = true
            this.tempClickTimeId = setTimeout(() => {
                clearTimeout(this.tempClickTimeId)
                this.isClickBtn = false
            }, 1500)

            if (!getCookieToken()) {
                return this.$Login.show({
                    scene: 'cb',
                    callback: () => {
                        this.$store.dispatch('getLimitFreeTime')
                    }
                })
            }

            if (this.currentStatus === 2) {
                if (this.isAlike) {
                    this.$NormalDialog.show({
                        msg: '您是否确定退出当前的游戏',
                        showConfirm: true,
                        confirmTxt: '确定',
                        confirmFn: () => {
                            this.userStopSteam()
                        }
                    })
                    return false
                }
            }

            this.type = 3
            // 还未领取过免费时长
            if (!this.$store.state.limitFreeTime) {
                if (this.requestLimit) return
                this.requestLimit = true
                getLimitFree()
                    .then(res => {
                        if (res.code == 200) {
                            this.$store.dispatch('getLimitFreeTime', {
                                fn: payload => {
                                    this.requestLimit = false
                                    if (payload.code == 200) {
                                        this.$Client.isSteamInstall()
                                    } else {
                                        console.log('start-game-sec', payload.msg)
                                    }
                                }
                            })
                        } else {
                            this.requestLimit = false
                        }
                    })
                    .catch(() => {
                        this.requestLimit = false
                        console.log('http请求出错')
                    })
            } else {
                this.$Client.isSteamInstall()
            }
        },
        async handlerIsSteamInstall(value) {
            try {
                await this.$Utils.checkClientUpdate(this)

                let formatValue = JSON.parse(value.data)
                if (formatValue.value == 1) {
                    // 实名认证
                    if (!canPlayGame(this, 'start-game')) {
                        return false
                    }
                    this.startGame()
                } else {
                    this.$ChooseSteamDir.show()
                }
            } catch (error) {
                console.log('=======>', error)
            }
        },
        isBuyGoods(g_id, s_id) {
            let gid_sid = this.$store.state.vipInfo.gid_sid
            if (!gid_sid) {
                return false
            } else {
                if (gid_sid[g_id] && gid_sid[g_id] == s_id) {
                    return true
                }
            }
            return false
        },
        customRound(num) {
            const decimalPart = num - Math.floor(num)
            if (decimalPart >= 0.5) {
                return Math.ceil(num)
            } else {
                return Math.floor(num)
            }
        },
        startGame() {
            console.log('this.type=======>', this.type)
            if (this.type == 1 || this.type == 3) {
                if (!this.goods.goodsInfo) {
                    console.log('err=======>', 1)
                    return this.$Toast.show('该游戏未配置商品')
                }
                if (this.goods.goodsInfo.is_enable !== 1) {
                    console.log('err=======>', 2)
                    return this.$Toast.show('该商品已下架')
                }
                try {
                    let item = this.goods.spList.find(v => v.mode == 1 && v.is_enable == 1)
                    if (item) {
                        this.firstShareSp = item
                    }
                } catch (error) {
                    console.log('err=======>', 3)
                    return this.$Toast.show('获取账号规格失败')
                }
                if (JSON.stringify(this.firstShareSp) == '{}') {
                    console.log('err=======>', 4)
                    return this.$Toast.show('获取账号规格失败')
                }
                if (this.firstShareSp.is_enable !== 1) {
                    console.log('err=======>', 5)
                    return this.$Toast.show('该商品规格已下架')
                }
            }
            // vip账号
            if (this.type == 1) {
                if (!this.is_vip) {
                    const { g_id, id } = this.firstShareSp
                    if (this.isBuyGoods(g_id, id)) {
                        this.getAccountInfo()
                    } else {
                        this.$router.push('/vip')
                    }
                } else {
                    const { vipInfo, serverTime } = this.$store.state
                    let calcVipTime = +new Date(vipInfo.expire_time) - +new Date(serverTime * 1000)
                    if (calcVipTime < 30 * 60 * 1000) {
                        this.$NormalDialog.show({
                            msg: `您的会员剩余时长已不足30分钟，若会员到期，会影响到您的使用体验，是否前往充值。`,
                            showCancel: true,
                            cancelTxt: '前往充值',
                            showConfirm: true,
                            confirmTxt: '开始游戏',
                            cancelFn: () => {
                                this.$router.push('/vip')
                            },
                            confirmFn: () => {
                                this.handerleft30MinutesClose()
                            },
                            closeFn: () => {}
                        })
                    } else {
                        this.getAccountInfo()
                    }
                }
            } else if (this.type == 2) {
                // 个人账号
                this.$Client.launchSteam()
                this.show = false
                const { game_id } = this.gameInfo
                const { goodsInfo } = this.goods
                if (goodsInfo && goodsInfo.id) {
                    this.updateUserGame(game_id, parseInt(goodsInfo.id))
                } else {
                    this.updateUserGame(game_id, 0)
                }
            } else if (this.type == 3) {
                // 免费游戏
                this.getAccountInfo()
            }
        },
        // 计算可以游玩的时长
        calcCanPlayTime() {
            const { vipInfo, serverTime, limitFreeTime } = this.$store.state
            let vipTime = +new Date(vipInfo.expire_time) - +new Date(serverTime * 1000),
                freeTime = +new Date(limitFreeTime) - +new Date(serverTime * 1000),
                calcPlayTime = 0,
                realMins = 0,
                calcMins = 0,
                formatServerTime = new Date(serverTime * 1000).toLocaleTimeString()

            // 存在没有领取过免费时长，此时limitFreeTime是空字符
            if (isNaN(freeTime)) {
                freeTime = 0
            } else if (this.gameInfo.is_family_free !== 1) {
                // 当前是非免费商品，需要要用会员时长
                freeTime = 0
            }

            calcPlayTime = Math.max(vipTime, freeTime)
            realMins = parseFloat((calcPlayTime / 1000 / 60).toFixed(1))
            calcMins = this.customRound(realMins)

            console.log('本地缓存的时间=======>', serverTime)
            console.log('限免时间=======>', limitFreeTime)
            console.log('vipTime=======>', vipTime / 1000 + '秒')
            console.log('freeTime=======>', freeTime / 1000 + '秒')
            console.log('calcPlayTime=======>', calcPlayTime / 1000 + '秒')
            console.log(`[type==>${this.type}] [webLocalTime==> ${formatServerTime}] [realMins=>${realMins}] [calcMins=>${calcMins}]`)
            return calcMins
        },
        // 获取账号
        getAccountInfo() {
            const { channel, client_id } = this.$store.state.clientInfo
            const { userInfo } = this.$store.state
            const data = {
                channel,
                e6: client_id,
                gs_id: this.firstShareSp.id,
                is_vip: this.is_vip
            }
            let requestPromise

            if (this.requestAccount) return
            this.requestAccount = true

            if (this.changeAccountPayload && this.changeAccountPayload.type == 'replace') {
                if (this.changeAccountPayload.is_e) {
                    data.is_e = this.changeAccountPayload.is_e
                }
                console.log('上号：----------------  切换账号')
                requestPromise = switchAccountInfo(data)
            } else {
                console.log('上号：----------------  创建账号')
                requestPromise = getAccountInfo(data)
            }

            this.changeAccountPayload = {}
            requestPromise
                .then(res => {
                    this.requestAccount = false
                    this.show = false
                    if (res.code == 200) {
                        const { r_account, r_pwd, account, pwd, order_no, is_free } = res.data
                        const { steam_appid, title, game_id } = this.gameInfo
                        const { goodsInfo } = this.goods
                        const { g_id, id } = this.firstShareSp
                        const isBuy = this.isBuyGoods(g_id, id)
                        // 购买过这个游戏，剩余时间给个100年 100 * 365 * 24 * 60
                        const remainingtime = isBuy ? 52560000 : this.calcCanPlayTime()

                        const accountInfo = {
                            appid: steam_appid,
                            id: userInfo.id,
                            goods_id: parseInt(goodsInfo.id),
                            goods_name: goodsInfo.name,
                            mode: 1,
                            token: getCookieToken(),
                            game_name: title,
                            isBuy, // 是否单独购买过这款游戏
                            free: is_free,
                            r_account,
                            r_pwd,
                            account,
                            pwd,
                            remainingtime: parseInt(remainingtime)
                        }
                        this.order_no = order_no
                        this.$Client.steam_login(accountInfo)
                        this.$store.commit('setAccountInfo', { ...accountInfo, game_id, clickType: this.type, is_free })
                        this.startMessageRotation()
                        // 开始游戏需要，记录用户玩的游戏
                        this.updateUserGame(game_id, parseInt(goodsInfo.id))
                        // 把左侧游玩的游戏列表滚动到当前正在玩的游戏
                        this.$EventBus.$emit('scroll-current-play-game', { goods_id: accountInfo.goods_id, game_id: this.gameInfo.game_id })
                        if (is_free == 1) {
                            localStorage.setItem(`use-free-${this.userId}`, JSON.stringify({ is_free, game_id: this.gameInfo.game_id }))
                        }
                    } else {
                        this.$NormalDialog.show({
                            msg: res.msg
                        })
                    }
                })
                .catch(() => {
                    this.requestAccount = false
                })
        },
        // 关闭离会员还有30分钟的弹框
        handerleft30MinutesClose() {
            if (!getCookieToken()) {
                return this.$Login.show({
                    scene: 'cb',
                    callback: () => {
                        this.exec30MinutesClose()
                    }
                })
            }
            this.exec30MinutesClose()
        },
        exec30MinutesClose() {
            const { vipInfo, serverTime } = this.$store.state
            let calcVipTime = +new Date(vipInfo.expire_time) - +new Date(serverTime * 1000)
            if (calcVipTime > 0) {
                this.getAccountInfo()
            }
        },
        handlerGameStartProgress(payload) {
            const params = JSON.parse(payload.data)
            const value = parseInt(params.value)
            if (isNaN(value)) {
            } else if (value < 100) {
                this.progress = value
                this.$store.commit('setCurrentGameStatus', 1)
            } else {
                // 只处理VIP账号和免费游戏上号
                clearInterval(this.$store.state.checkVipInfoTimeId)
                if (this.type == 1 || this.type == 3) {
                    const { accountInfo, serverTime } = this.$store.state
                    this.resetStartStatus()
                    this.$store.commit('setCurrentGameStatus', 2)
                    this.$store.commit('setAccountInfo', { ...accountInfo, startTime: serverTime })
                    clearInterval(this.messageInterval)
                    // steam登录成功后，每隔一段时间获取会员信息，没有买下这款商品（会员时间\免费时间）
                    if (!accountInfo.isBuy && (accountInfo.clickType == 1 || accountInfo.clickType == 3)) {
                        console.log('emit=======>', 'check-vip')
                        this.$EventBus.$emit('check-vip')
                    }
                    if (accountInfo.free == 1) {
                    }
                } else {
                    this.$store.commit('setCurrentGameStatus', 0)
                    this.type = -1
                }
            }
        },
        resetStartStatus() {
            this.progress = 0
            this.currentTxtIndex = 0
            this.pingValue = 0
            this.$store.commit('setCurrentGameStatus', 0)
        },
        handlerGameStartErrorTip(payload) {
            const params = JSON.parse(payload.data)
            const code = parseInt(params.code)
            if (code == 8) {
                // 密码错误，可以切换账号
                this.saveType = this.$store.state.accountInfo.clickType
                this.$NormalDialog.show({
                    msg: this.errorTxt[code],
                    showConfirm: true,
                    confirmTxt: '切换账号',
                    confirmFn: () => {
                        this.$changeAccount.show(() => {
                            this.changeAccountPayload = { type: 'replace', is_e: 99 }
                            this.type = this.saveType
                            this.startGame()
                        })
                    }
                })
                this.resetStartStatus()
                this.$store.commit('setAccountInfo', {})
            } else if (code != 4) {
                this.$NormalDialog.show({
                    msg: this.errorTxt[code],
                    showConfirm: true,
                    confirmTxt: '联系客服',
                    confirmFn: () => {
                        window.open(this.$store.getters.customerLink, '_blank')
                    }
                })
                this.resetStartStatus()
                this.$store.commit('setAccountInfo', {})
            } else if (code == 4) {
                // 获取邮箱验证码
                const tempTimeId = setTimeout(() => {
                    clearTimeout(tempTimeId)
                    this.requestEmailCode()
                })
            }
        },
        handlerSteamLaunchError(payload) {
            const params = JSON.parse(payload.data)
            const code = parseInt(params.code)
            if (code == 6) {
                // 针对使用个人账号，已经启动steam的情况
                this.$Toast.show('steam已打开')
            } else {
                this.resetStartStatus()
                this.$NormalDialog.show({
                    msg: `启动steam失败，错误码[${code}]`,
                    showConfirm: true,
                    confirmTxt: '联系客服',
                    confirmFn: () => {
                        window.open(this.$store.getters.customerLink, '_blank')
                    }
                })
            }
        },
        ping(payload) {
            let value = ''
            try {
                const params = JSON.parse(payload.data)
                value = parseInt(params.value)
                this.pingValue = value
            } catch (error) {}
        },
        locateSteam(payload) {
            let value = ''
            try {
                const params = JSON.parse(payload.data)
                value = parseInt(params.value)
                if (value == 1) {
                    this.$ChooseSteamDir.close()
                    this.$Toast.show('设置成功')
                }
            } catch (error) {}
        },
        startMessageRotation() {
            clearInterval(this.messageInterval)
            this.messageInterval = setInterval(() => {
                this.currentTxtIndex++
                if (this.currentTxtIndex > 2) {
                    if (this.pingValue > config.PING_VALUE) {
                        clearInterval(this.messageInterval)
                        this.pingTimeId = setTimeout(() => {
                            this.currentTxtIndex = 0
                            this.startMessageRotation()
                        }, 3000)
                    } else {
                        this.currentTxtIndex = 0
                    }
                }
            }, 3000)
        },
        // 获取邮箱验证码
        async requestEmailCode() {
            // acc_id:开启任务获取的邮箱验证码
            const query = { order_no: this.order_no, acc_id: '' }
            clearTimeout(this.getEmailCodeTimeId)
            try {
                const res = await getEmailCode(query)
                if (res.code == 200) {
                    clearTimeout(this.getEmailCodeTimeId)
                    this.code = res.data.code
                    this.$Client.FillInAuthCode({ code: this.code })
                } else {
                    this.getEmailCodeTimeId = setTimeout(() => {
                        this.requestEmailCode()
                    }, 4000)
                }
            } catch (error) {
                this.$Toast.show('无法获取到验证码，请联系客服')
            }
        },
        // 用户点击退出steam之后的操作
        userStopSteam() {
            this.$store.commit('setAccountInfo', {})
            this.$store.commit('setCurrentGameStatus', 0)
            this.$Client.stopSteam()
        },
        // 用户添加游戏
        updateUserGame(game_id, goods_id) {
            if (this.userGameInfo.id) return false

            boxUserGameCreate({ game_id, goods_id }).then(res => {
                if (res.code == 200) {
                    // 更新游戏详情页面顶部
                    this.$EventBus.$emit('update-game-follow', { id: res.data.id })
                    // 更新侧边栏
                    this.$EventBus.$emit('update-user-game', { type: 'add', id: res.data.id })
                }
            })
        },
        changeGameAccount() {
            this.changeAccountPayload = { type: 'replace', is_e: 0 }
            this.$changeAccount.show(() => {
                this.type = this.$store.state.accountInfo.clickType
                this.startGame()
            })
        }
    }
}
</script>
<style lang="less" scoped>
.start-game-sec-comp {
    height: 60px;
    width: 100%;
    background: #282d32 center/100% no-repeat;
    border-radius: 10px 10px 0px 0px;
    display: flex;

    .lf-sec {
        position: relative;
        flex: 1;

        .progress {
            position: absolute;
            height: 100%;
            top: 0;
            right: 0;
            background: #282d32;
            border-radius: 10px 0 0 0;

            .shadow {
                position: absolute;
                width: 100px;
                height: 40px;
                top: 0;
                left: 0;
                box-shadow: 0 12px 10px 10px #282d32;
            }
        }

        .lf-inner {
            position: absolute;
            display: flex;
            align-items: center;
            padding-left: 20px;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;

            .icon {
                margin-right: 8px;
                width: 20px;
                height: 19px;
                background: url(../../../assets/msg-icon.png) center/100% no-repeat;
            }

            .txt {
                font-size: 14px;
            }
        }
    }

    .rg-sec {
        position: relative;
        flex-shrink: 0;
        width: 255px;
        height: 60px;

        .inner {
            position: relative;
            border-radius: 0px 10px 0px 0px;
            width: 100%;
            height: 100%;
            cursor: pointer;
            .flex-center();
            flex-direction: column;
            background: linear-gradient(133deg, #03dc49, #05ba7f);

            &:hover {
                background: linear-gradient(133deg, #00f14e, #02cb8a);
            }

            &.no-show {
                &:active {
                    background: linear-gradient(133deg, rgba(0, 241, 78, 0.8), rgba(2, 203, 138, 0.8));
                }
            }

            .play-txt,
            .play-time {
                width: 100%;
                .flex-center();
            }

            .play-time {
                font-size: 14px;
                color: @bg-color-00;
            }

            .play-txt {
                .sp1 {
                    font-size: 18px;
                    font-weight: bold;
                    color: @bg-color-00;
                    margin-right: 8px;

                    &.only-sp1 {
                        width: 100%;
                        height: 100%;
                        .flex-center();
                        margin-right: 0;
                    }
                }

                .sp2 {
                    .flex-center();
                    width: 18px;
                    height: 18px;

                    i {
                        width: 18px;
                        height: 10px;
                        background: url(../../../assets/start_game_arr.png) center/100% no-repeat;
                    }

                    &.change-arr {
                        i {
                            width: 17px;
                            height: 14px;
                            background: url(../../../assets/change-arr.png) center/100% no-repeat;
                        }
                    }
                }
            }

            .choose-wrap {
                position: absolute;
                left: 0;
                top: -118px;
                width: 255px;
                padding: 25px 0;
                background: @bg-color-39;
                border-radius: 10px;
                .flex-center();
                flex-direction: column;

                &.has-two-btn {
                    top: -168px;
                }

                .btn {
                    .flex-center();
                    width: 195px;
                    height: 50px;
                    background: linear-gradient(125deg, #f5c666, #fbeab9);
                    border-radius: 25px;
                    color: @bg-color-05;
                    font-size: 18px;
                    font-weight: bold;

                    &:active {
                        background: linear-gradient(125deg, #f5c86e, #fffeec);
                    }

                    &.dv2 {
                        margin-top: 10px;
                    }
                }
            }
        }

        .starting-cover {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            cursor: not-allowed;
            background: rgba(0, 0, 0, 0.43);
        }
    }

    .transparent-mask {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
    }
}
</style>
